import React from 'react';
import { motion } from 'framer-motion';
import { Heart } from 'lucide-react';
import { useFavoriteVenues } from '../../hooks/useFavoriteVenues';
import { feedbackLike, hapticTap } from '../../utils/appFeedback';

// Small, reusable heart toggle for guest venue cards. Lives on top of the
// hero image (top-left, mirroring the rating pill on the right).
export function VenueFavoriteButton({
  venueId,
  size = 'md', // 'md' | 'sm'
  variant = 'overlay', // 'overlay' (sits on imagery) | 'plain' (no chrome)
  testIdPrefix = 'venue-favorite',
  onChange,
}) {
  const { isFavorite, toggleFavorite } = useFavoriteVenues();
  const liked = isFavorite(venueId);

  const dimensions =
    size === 'sm'
      ? { box: 32, icon: 16 }
      : { box: 38, icon: 19 };

  const baseStyle =
    variant === 'overlay'
      ? {
          width: dimensions.box,
          height: dimensions.box,
          borderRadius: '50%',
          background: 'rgba(18,18,28,0.55)',
          backdropFilter: 'blur(6px)',
          WebkitBackdropFilter: 'blur(6px)',
          border: 'none',
        }
      : {
          width: dimensions.box,
          height: dimensions.box,
          borderRadius: '50%',
          background: 'transparent',
          border: 'none',
        };

  return (
    <motion.button
      type="button"
      data-testid={`${testIdPrefix}-${venueId}`}
      aria-label={liked ? 'Remove from saved' : 'Save venue'}
      aria-pressed={liked}
      onClick={(event) => {
        event.stopPropagation();
        // Playful pop when adding; softer tap when removing.
        if (!liked) feedbackLike(); else hapticTap();
        toggleFavorite(venueId);
        onChange?.(!liked);
      }}
      whileTap={{ scale: 0.82 }}
      whileHover={{ scale: 1.06 }}
      animate={liked ? { scale: [1, 1.22, 1] } : { scale: 1 }}
      transition={{ duration: 0.28, ease: [0.22, 1.2, 0.36, 1] }}
      style={{
        ...baseStyle,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        padding: 0,
      }}
    >
      <Heart
        size={dimensions.icon}
        strokeWidth={2.2}
        fill={liked ? '#FF3B5C' : 'transparent'}
        color={
          liked ? '#FF3B5C' : variant === 'overlay' ? '#FFFFFF' : '#9C93BD'
        }
      />
    </motion.button>
  );
}
